import React, { Component } from 'react'
import { Row, Col, DatePicker, TimePicker, Alert, Checkbox, Select } from 'antd'
import moment from 'moment'

const dateFormat = 'YYYY/MM/DD'
const format = 'HH:mm'
const Option = Select.Option

class SimpleIssueStep1 extends Component {

    render() {
        return (
            <div className={this.props.className}>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}>
                        <legend>Identificação</legend>
                        { this.props.v.show ? (
                            <div>
                                <Alert message="Verifique os campos assinalados a vermelho" type="error" showIcon />
                                <hr />
                            </div>
                        ) : '' }
                    </Col>
                </Row>

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                        <label htmlFor="roles_id" className="ant-form-item-required" title="Perfil de Utilizador">
                            Tipo
                        </label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                        <Select value={this.props.issue_type ? ''+this.props.issue_type : null}
                            showSearch
                            placeholder="Escolha o tipo de reporte"
                            optionFilterProp="children"
                            onChange={(v) => this.props.onChangeField('issue_type', v)}>
                            { this.props.issue_type_options.map((item) => (
                                <Option key={''+item} value={''+item}>{item}</Option>
                            ) )}
                        </Select>
                    </div>
                </div>

                { this.props.issue_type === "Programa CoastSnap" && (
                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="roles_id" className="ant-form-item" title="Perfil de Utilizador">
                                Programa
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                            <Select value={this.props.programa_id ? ''+this.props.programa_id : null}
                                showSearch
                                allowClear
                                placeholder="Escolha um programa (se aplicável)"
                                optionFilterProp="children"
                                onChange={(v) => this.props.onChangeField('programa_id', v)}>
                                { this.props.programs.map((item) => (
                                    <Option key={''+item.id} value={''+item.id}>{item.titulo}</Option>
                                ) )}
                            </Select>
                        </div>
                    </div>
                )}

                <input type="hidden" id="user" ref="user" value={this.props.user} />

                <div className="ant-row ant-form-item">
                    <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                        <label htmlFor="issuedate" className="ant-form-item-required" title="Data e Hora">
                            Data | Hora da Ocorrência
                        </label>
                    </div>
                    <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14" id="issueDateWrapper">
                        <DatePicker value={moment(this.props.issue_date, dateFormat)} format={dateFormat}
                            allowClear={false}
                            onChange={(date, dateStr) => {this.props.onChangeField('issue_date', dateStr)}}
                        />
                        <TimePicker value={moment(this.props.issue_time, format)} format={format}
                            disabled={!!this.props.data_ocorrencia_tipo}
                            onChange={(time, timeStr) => {this.props.onChangeField('issue_time', timeStr)}}
                        />
                        {' '}
                        <Checkbox
                            checked={!!this.props.data_ocorrencia_tipo}
                            onChange={(e) => this.props.onChangeField('data_ocorrencia_tipo', e.target.checked ? 1 : 0)}
                            >
                            Indeterminada
                        </Checkbox>
                    </div>
                </div>

                <input type="hidden" id="issue_reg_local_date" ref="issue_reg_local_date" value={this.props.issue_reg_local_date} />
                <input type="hidden" id="issue_reg_local_time" ref="issue_reg_local_time" value={this.props.issue_reg_local_time} />
                
                <input type="hidden" id="issue_reg_date" ref="issue_reg_date" value={this.props.issue_reg_date} />
                <input type="hidden" id="issue_reg_time" ref="issue_reg_time" value={this.props.issue_reg_time} />
                <input type="hidden" id="issue_detection" ref="issue_detection" value={this.props.issue_detection} />

            </div>
        )
    }
}

export default SimpleIssueStep1;



// WEBPACK FOOTER //
// ./src/components/SimpleIssueStep1.js